module.exports = __webpack_public_path__ + "static/media/twinkle-color-01.6aa175eb.png";